import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import themes from "./themes";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
// import LogRocket from "logrocket";
// import { LogRocketEnv } from "./config/config";
// import { initializePostHog } from "./config/posthog";

// Initial state for login
const initialLoginState = {
  isAuthenticated: false,
};

// Login reducer
const loginReducer = (state = initialLoginState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

// Root reducer
const rootReducer = combineReducers({
  login: loginReducer,
});

// Create store
const store = createStore(rootReducer, applyMiddleware(thunk));

const theme = createTheme({ ...themes.default });


// try {
//   if (process.env.REACT_APP_MODE === "production") {
//     initializePostHog();
//   }
// } catch (error) {
//   console.warn(
//     "PostHog initialization failed, continuing without analytics:",
//     error
//   );
// }

// if (process.env.REACT_APP_MODE === "production") {
//   LogRocket.init(LogRocketEnv, { mergeIframes: true });
//   window.LogRocket = LogRocket;
// }

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
